import { render, staticRenderFns } from "./PopupManageContactPersonComponent.vue?vue&type=template&id=130cccc6"
import script from "./PopupManageContactPersonComponent.vue?vue&type=script&lang=js"
export * from "./PopupManageContactPersonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports